/**
 * ページトップボタン
 */

const windowInfo = require('../common/window_info');

// ページトップへ移動中かどうかを識別するフラグ
let scrollFlg = false;

/* "passive" が使えるかどうかを検出 */
let passiveSupported = false;
try {
  window.addEventListener(
    'test',
    null,
    Object.defineProperty({}, 'passive', {
      get() {
        passiveSupported = true;
      },
    }),
  );
} catch (err) {}

function init() {
  document.addEventListener('DOMContentLoaded', () => {
    const element = document.getElementById('js-pageTop');

    function runPageTop() {
      const scrollPosition = window.pageYOffset;

      window.scrollTo(0, Math.floor(scrollPosition * 0.8));
      if (scrollPosition > 0) {
        window.setTimeout(runPageTop);
      } else {
        element.classList.remove('is-active');
      }
    }

    element.addEventListener('click', (e) => {
      e.preventDefault();

      runPageTop();
    });

    window.addEventListener(
      'scroll',
      () => {
        if (!scrollFlg) {
          window.requestAnimationFrame(() => {
            if (window.pageYOffset > windowInfo.height()) {
              element.classList.add('is-active');
            }
            scrollFlg = false;
          });

          scrollFlg = true;
        }
      },
      passiveSupported ? { passive: true } : false,
    );
  });
}

module.exports = init;
